<template>
  <div class="MyMapLayerOpacityPicker">
    <div class="MyMapLayerOpacityPicker__desc">
      <span class="MyMapLayerOpacityPicker__label">{{ $t('myMap.components.opacity') }}</span>
      <span class="MyMapLayerOpacityPicker__value">{{ opacity }}%</span>
    </div>
    <div class="MyMapLayerOpacityPicker__sliderWrapper">
      <div class="MyMapLayerOpacityPicker__sliderFill" :style="{ width: `${opacity}%` }"></div>
      <input
        type="range"
        v-model.number="opacity"
        min="0"
        max="100"
        step="1"
        class="MyMapLayerOpacityPicker__slider"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const opacity = defineModel({
  default: 100,
})
</script>

<style lang="scss">
.MyMapLayerOpacityPicker {
  display: flex;
  flex-flow: column nowrap;
  gap: 0.75rem;
  padding: 1rem;

  .MyMapLayerOpacityPicker__desc {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: space-between;

    .MyMapLayerOpacityPicker__label {
      font-size: 0.875rem;
      color: rgb(var(--v-theme-main-black));
    }

    .MyMapLayerOpacityPicker__value {
      font-weight: 600;
      font-size: 0.875rem;
      color: rgb(var(--v-theme-main-blue));
      min-width: 3rem;
      text-align: right;
    }
  }

  .MyMapLayerOpacityPicker__sliderWrapper {
    position: relative;
    width: 100%;
    height: 4px;
    margin: 0.75rem 0;
    background: rgb(var(--v-theme-main-grey));
    border-radius: 2px;
    overflow: hidden;

    .MyMapLayerOpacityPicker__sliderFill {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      background: rgb(var(--v-theme-main-blue));
      border-radius: 2px;
      pointer-events: none;
      z-index: 1;
      transition: width 0.1s ease;
    }
  }

  .MyMapLayerOpacityPicker__slider {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    -webkit-appearance: none;
    appearance: none;
    background: transparent;
    cursor: pointer;
    z-index: 2;
    outline: none;

    &::-webkit-slider-track {
      width: 100%;
      height: 4px;
      background: transparent;
      border-radius: 2px;
    }

    &::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 16px;
      height: 16px;
      background: #fff;
      border: 1.5px solid rgb(var(--v-theme-main-blue));
      border-radius: 50%;
      cursor: pointer;
      margin-top: -6px;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
      transition: box-shadow 0.15s ease;
    }

    &::-webkit-slider-thumb:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    &::-webkit-slider-thumb:active {
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    }

    &::-moz-range-track {
      width: 100%;
      height: 4px;
      background: transparent;
      border-radius: 2px;
    }

    &::-moz-range-thumb {
      width: 16px;
      height: 16px;
      background: #fff;
      border: 1.5px solid rgb(var(--v-theme-main-blue));
      border-radius: 50%;
      cursor: pointer;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
      transition: box-shadow 0.15s ease;
    }

    &::-moz-range-thumb:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    &::-moz-range-thumb:active {
      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
    }

    &:focus {
      outline: none;

      &::-webkit-slider-thumb {
        box-shadow: 0 0 0 3px rgba(var(--v-theme-main-blue-rgb, 0, 0, 255), 0.1);
      }

      &::-moz-range-thumb {
        box-shadow: 0 0 0 3px rgba(var(--v-theme-main-blue-rgb, 0, 0, 255), 0.1);
      }
    }

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;

      &::-webkit-slider-thumb {
        cursor: not-allowed;
      }

      &::-moz-range-thumb {
        cursor: not-allowed;
      }
    }
  }
}
</style>
